import React from 'react';
import InvestmentBanner from './components/InvestmentBanner';
import RecordInfo from './components/RecordInfo';
import { Layout } from 'antd';

const { Content } = Layout;

function App() {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ padding: '50px 24px' }}>
        <InvestmentBanner />
      </Content>
      <RecordInfo />
    </Layout>
  );
}

export default App;
